import {
  Component,
  Input,
  SimpleChanges,
  OnChanges,
  OnDestroy,
  ChangeDetectionStrategy,
} from '@angular/core';
import { Chart } from 'angular-highcharts';
import { DateUtils } from 'src/app/shared/utils/date.utils';

@Component({
  selector: 'app-micro-chart',
  templateUrl: './micro-chart.component.html',
  styleUrls: ['./micro-chart.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class MicroChartComponent implements OnChanges, OnDestroy {
  /** Pre-computed chart series: [timestamp, count][] */
  @Input() seriesData: [number, number][];
  @Input() timeframe: string;

  stockChart: Chart;

  private chartOptions: Highcharts.Options = {
    title: { text: undefined },
    chart: {
      backgroundColor: 'transparent',
      borderWidth: 0,
      type: 'area',
      margin: [2, 0, 2, 0],
      width: 140,
      height: 25,
      style: {
        overflow: 'visible',
      },
    },
    xAxis: {
      labels: { enabled: false },
      title: { text: null },
      lineWidth: 1,
      lineColor: 'rgb(50, 50, 50)',
      gridLineWidth: 0,
      gridLineColor: 'transparent',
      startOnTick: false,
      endOnTick: false,
      tickPositions: [],
    },
    yAxis: {
      endOnTick: false,
      startOnTick: false,
      labels: { enabled: false },
      title: { text: null },
      gridLineWidth: 0,
      gridLineColor: 'transparent',
      tickPositions: [],
    },
    exporting: { enabled: false },
    credits: { enabled: false },
    legend: { enabled: false },
    tooltip: { enabled: false },
    plotOptions: {
      series: {
        animation: false,
        shadow: false,
      },
      column: {
        pointWidth: 5,
        grouping: false,
        borderColor: 'transparent',
      },
    },
    series: [
      {
        name: '',
        type: 'area',
        data: [],
      } as Highcharts.SeriesOptionsType,
    ],
  };

  constructor() {}

  ngOnChanges(changes: SimpleChanges): void {
    if (!changes.seriesData && !changes.timeframe) {
      return;
    }

    const range = this.getRange();
    this.chartOptions.series = [
      {
        type: 'column',
        color: '#1e816c',
        data: this.seriesData || null,
      } as Highcharts.SeriesOptionsType,
    ];
    this.chartOptions.xAxis = {
      ...(this.chartOptions.xAxis as Highcharts.XAxisOptions),
      type: 'datetime',
      ordinal: false,
      min: range.min,
      max: range.max,
    };
    this.stockChart = new Chart(this.chartOptions);
  }

  ngOnDestroy(): void {
    this.stockChart?.destroy();
  }

  private getRange(): { min: number; max: number } {
    const fromto = DateUtils.chartFromTo(this.timeframe);
    return {
      min: new Date(fromto.dateFrom + 'T00:00:00Z').getTime(),
      max: new Date(fromto.dateTo + 'T00:00:00Z').getTime(),
    };
  }
}
